/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
// @ts-nocheck
import amiMarker from '../../assets/maps/amiMarker.svg'
import React, { useEffect, useState } from 'react'
import { GoogleMap, InfoWindow, LoadScript, MarkerClustererF, MarkerF } from '@react-google-maps/api'
import { Link, useNavigate } from 'react-router-dom'
import criticalBadge from '../../assets/maps/criticalBadge.png'
import highBadge from '../../assets/maps/highBadge.png'
import mapOptions from '../../assets/maps/mapOptions.json'
import { type ConnectedProps, connect, useDispatch } from 'react-redux'
import { changeAssetId } from '../device-details/redux/assetIdSlice'
import { fetchAllActiveAlarms } from '../ami-meter-data-collection/redux/actionCreators'
import { type AlarmDataState } from '../ami-meter-data-collection/redux/allAlarmsSlice'
import { type RootState } from '../../store'
import { useAuth } from 'react-oidc-context'

interface MapProps {
  AMIMarkers: AMIMarkerData[] | []
}
export interface AMIMarkerData {
  assetName: string
  location: {
    lat: number
    lng: number
  }
  severity: string
  assetId: string
}

type MarkersGroupedByAssetId = Record<string, AMIMarkerData[]>

const containerStyle = {
  width: '100%',
  height: '100%'
}

const options: google.maps.MapOptions = {
  styles: mapOptions
}

export function nortBadge (severity: string): any {
  if (severity === 'major') return highBadge
  else return criticalBadge
}

const Map = (props: AllProps): any => {
  let centerLat = 0
  let centerLng = 0
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const auth = useAuth()
  const [centerLocation, setCenterLocation] = useState<{ lat: number, lng: number }>({ lat: 0, lng: 0 })
  const [zoomLevel, setZoomLevel] = useState<number>(8)
  const [selectedMarker, setSelectedMarker] = useState<any>(null)
  const [assetMarker, setAssetMarker] = useState<AMIMarkerData[] | []>([])

  // istanbul ignore next
  const GoogleMapsApiKey = typeof window._env_?.REACT_APP_GOOGLE_MAPS_API_KEY === 'string' ? window._env_.REACT_APP_GOOGLE_MAPS_API_KEY : ''

  useEffect(() => {
    // istanbul ignore else
    if (props.AMIMarkers.length > 0) {
      const markers: MarkersGroupedByAssetId = {}
      props.AMIMarkers.forEach((marker: AMIMarkerData) => {
        // istanbul ignore else
        if (!(marker.assetId in markers)) {
          markers[marker.assetId] = []
          markers[marker.assetId].push(marker)
        } else {
          markers[marker.assetId].push(marker)
        }
      })

      const uniqueAMIMarkers = []

      for (const asset in markers) {
        let hasCritical = false
        // istanbul ignore next
        for (const amiMarker of markers[asset]) {
          if (amiMarker.severity === 'critical') {
            uniqueAMIMarkers.push(amiMarker)
            hasCritical = true
            break
          }
        }
        // istanbul ignore else
        if (!hasCritical && markers[asset].length > 0) {
          uniqueAMIMarkers.push(markers[asset][0])
        }
      }

      setAssetMarker(uniqueAMIMarkers)

      // istanbul ignore next
      centerLat = uniqueAMIMarkers.reduce((total, element) => total + (element.location.lat ?? 0), 0) / uniqueAMIMarkers.length
      // istanbul ignore next
      centerLng = uniqueAMIMarkers.reduce((total, element) => total + (element.location.lng ?? 0), 0) / uniqueAMIMarkers.length

      setCenterLocation({ lat: centerLat, lng: centerLng })
      setZoomLevel(4)
    }
  }, [props.AMIMarkers])

  useEffect(() => {
    props.fetchAllActiveIssues(
      0,
      10000,
      'asc',
      'assetName',
      auth.user?.profile.customer as string
    )
  }, [])

  // istanbul ignore next
  const handleDeviceDetailClick = (
    assetId: string,
    assetName: string
  ): void => {
    dispatch(changeAssetId(assetId))
    sessionStorage.setItem(
      'paramAssetId',
      assetId != null ? assetId.toString() : ''
    )
    sessionStorage.setItem(
      'paramAssetName',
      assetName != null ? assetName.toString() : ''
    )
    navigate('/devicedetails')
  }

  if (assetMarker.length > 0) {
    return (
      <LoadScript
        googleMapsApiKey={GoogleMapsApiKey}
      >
        <GoogleMap
            mapContainerStyle={ containerStyle }
            center={ centerLocation }
            zoom={ zoomLevel }
            options={ options }
            id={ 'map' }
        >
          <MarkerClustererF
            zoomOnClick={true}
            options={
              {
                gridSize: 80
              }
            }
          >
            {
              // istanbul ignore next
              (clusterer: any) => (
              <div>
                {assetMarker.map((obj, i) => {
                  if (obj.location.lat !== null && obj.location.lng !== null) {
                    return (
                      <MarkerF
                  key={i}
                  position={{ lat: obj.location.lat, lng: obj.location.lng }}
                  icon={ <svg>{amiMarker}</svg> as any }
                  onClick={() => {
                    // istanbul ignore next
                    setSelectedMarker(obj)
                    setCenterLocation({ lat: obj.location.lat, lng: obj.location.lng })
                  }
                  }
                  clusterer={clusterer}
                />
                    )
                  }
                  // istanbul ignore next
                  return undefined
                })}
              </div>
              )}
          </MarkerClustererF>
          {(selectedMarker != null) && (
            // istanbul ignore next
            <InfoWindow
              onCloseClick={
                // istanbul ignore next
                () => {
                  setSelectedMarker(null)
                }}
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              position={ { lat: selectedMarker.location.lat + 0.00001, lng: selectedMarker.location.lng } }
            >
              <>
                <div id='popupDivAmi'>
                  <div>Asset Name: <span>{selectedMarker.assetName}</span></div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={nortBadge(selectedMarker.severity)}/>
                    {
                      props.AMIMarkers.length > 0
                        ? <span>
                          +
                        {props.AMIMarkers.filter(
                          // istanbul ignore next
                          (marker: AMIMarkerData) => marker.assetName === selectedMarker.assetName).length - 1
                        }
                      </span>
                        : ''}
                  </div>
                </div>
                <Link
                  to={'/devicedetails'}
                  onClick={
                    // istanbul ignore next
                    () => {
                      handleDeviceDetailClick(selectedMarker.assetId, selectedMarker.assetName)
                    }}
                >
                  View Details
                </Link>
              </>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    )
  } else {
    return (
      <LoadScript
        googleMapsApiKey={GoogleMapsApiKey}
      >
        <GoogleMap
            mapContainerStyle={ containerStyle }
            center={ { lat: 27.988236190337403, lng: 86.92517183841176 } }
            zoom={ zoomLevel }
            options={ options }
            id={ 'map' }
        >
        </GoogleMap>
      </LoadScript>
    )
  }
}

interface DispatchToProps {
  fetchAllActiveIssues: (
    page: number,
    size: number,
    sortdir: string,
    sortfield: string,
    tenantId: string
  ) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchAllActiveIssues: (
    page: number,
    size: number,
    sortdir: string,
    sortfield: string,
    tenantId: string
  ) => dispatch(fetchAllActiveAlarms(page, size, sortdir, sortfield, tenantId))
})

interface StateToProps {
  allActiveIssues: AlarmDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  allActiveIssues: state.allActiveIssues
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = MapProps & PropsFromRedux

export default connector(Map)
